import { createConsumer } from '@rails/actioncable';
import { find } from 'lodash';
import { errorMessage } from '../actions/internal';

export default function cableMiddleware() {
  const cable = createConsumer();

  return store => next => action => {
    if (typeof(action) === 'function') {
      return next(action);
    }

    const { channel, room, leave } = action;
    let { received } = action;

    if (!channel) {
      return next(action);
    }

    if (leave) {
      const subscription = find(
        cable.subscriptions.subscriptions,
        sub => sub.identifier === JSON.stringify({ channel, room }),
      );

      return cable.subscriptions.remove(subscription);
    }

    if (typeof(received) === 'string') {
      const type = received;
      received = result => {
        return store.dispatch({ type, payload: result });
      }
    }

    let rejected = () => {
      return store.dispatch(errorMessage('Smth wrong happened during chat creation'));
    }

    return cable.subscriptions.create({ channel, room }, { received, rejected });
  };
}
